export const version = '2.9.0'
export const name = 'js-libp2p'
